import { render, staticRenderFns } from "./channelDevelopment.vue?vue&type=template&id=59adbdc0"
import script from "./channelDevelopment.vue?vue&type=script&lang=js"
export * from "./channelDevelopment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59adbdc0')) {
      api.createRecord('59adbdc0', component.options)
    } else {
      api.reload('59adbdc0', component.options)
    }
    module.hot.accept("./channelDevelopment.vue?vue&type=template&id=59adbdc0", function () {
      api.rerender('59adbdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/reportModule/channelDevelopment.vue"
export default component.exports